import {
  Box,
  Card,
  CardActions,
  CardContent,
  styled,
  Typography,
} from '@mui/material'
import { AppshellButton } from '@trr/internal-helpers'
import HTMLMapper from 'App/Epi/HTMLMapper'
import { getBackgroundColor } from 'App/hooks/getBackgroundColor'

export interface FactBlockProps {
  properties: {
    heading: string
    body?: string
    button?: {
      text: string
      url?: string
    }
    color: string
  }
}

const ColorHandler = styled(Card, {
  shouldForwardProp: (props: string) => !['color'].includes(props),
})<{ color: string }>(({ theme, color }) => ({
  ...(color !== 'transparent' && {
    backgroundColor: getBackgroundColor(theme, color, true),
    color: 'currentColor',
    border: 0,
    'li::before': {
      background: 'currentColor',
    },
  }),
  marginBottom: theme.spacing(6),
}))

const BodyWrapper = styled(Box)({
  '& :last-child': {
    marginBottom: 0,
  },
})

const FactBlock = ({
  properties: { heading, body, button, color },
}: FactBlockProps) => {
  return (
    <ColorHandler
      color={color}
      data-component="FactBlock"
      data-testid="fact-block"
    >
      <CardContent>
        <Typography variant="h6">{heading}</Typography>
        {body && (
          <BodyWrapper pt={1.5}>
            <HTMLMapper body={body} />
          </BodyWrapper>
        )}
      </CardContent>

      {button?.url && button?.text && (
        <CardActions>
          <AppshellButton
            url={button.url}
            text={button.text}
            dataTestId="fact-block--link"
            variant="text"
            size="small"
          />
        </CardActions>
      )}
    </ColorHandler>
  )
}

export default FactBlock
